import "./styles.css";
export const DashLayoutGrid = (props) => {
  return (
    <div className="container-dash-grid">
      <div className="container-login-dash-grid">
        <div className="wrap-login-dash-grid">{props.children}</div>
      </div>
    </div>
  );
};
